import { observable } from "mobx";
import { STORE_TABLE, TableStore } from "./TableStore";
import { STORE_TABLESUM, TableSumStore } from "./TableSumStore";
import { AuthStore, STORE_AUTH } from "./AuthStore";
import { StatsStore, STORE_STATS } from "./StatsStore";
import { ConfigStore, STORE_CONFIG } from "./ConfigStore";
import { MapStore, STORE_MAP } from "./MapStore";
import { EventlogsStore, STORE_EVENTLOGS } from "./EventlogsStore";
import { SealnumsStore, STORE_SEALNUMS } from "./SealnumsStore";
import { WorkshiftStore, STORE_WORKSHIFT } from "./WorkshiftStore";
import { QualitiesStore, STORE_QUALITIES } from "./QualitiesStore";
import { MixesStore, STORE_MIXES } from "./MixesStore";
import { StatActivityStore, STORE_STAT_ACTIVITY } from "./StatActivityStore";
import { STORE_PALLET_CHECK, PalletCheckStore } from "./PalletCheckStore";
import {
  STORE_TRANSPORTER_MOVE,
  TransporterMoveStore,
} from "./TransporterMoveStore";
import {
  STORE_TRANSPORTER_CHECK,
  TransporterCheckStore,
} from "./TransporterCheckStore";

class AppStore {
  @observable stores = {};

  constructor(rawState = {}) {
    const stores = {};

    stores[STORE_CONFIG] = new ConfigStore(rawState[STORE_CONFIG]);
    stores[STORE_AUTH] = new AuthStore(rawState[STORE_AUTH]);
    stores[STORE_TABLE] = new TableStore(
      rawState[STORE_TABLE],
      stores[STORE_CONFIG],
      stores[STORE_AUTH]
    );
    stores[STORE_TABLESUM] = new TableSumStore(
      rawState[STORE_TABLESUM],
      stores[STORE_CONFIG],
      stores[STORE_AUTH]
    );
    stores[STORE_STATS] = new StatsStore(rawState[STORE_STATS]);
    stores[STORE_MAP] = new MapStore(rawState[STORE_MAP], stores[STORE_CONFIG]);
    stores[STORE_EVENTLOGS] = new EventlogsStore(
      rawState[STORE_EVENTLOGS],
      stores[STORE_CONFIG]
    );
    stores[STORE_SEALNUMS] = new SealnumsStore(rawState[STORE_SEALNUMS]);
    stores[STORE_WORKSHIFT] = new WorkshiftStore(
      rawState[STORE_WORKSHIFT],
      stores[STORE_CONFIG]
    );
    stores[STORE_QUALITIES] = new QualitiesStore(
      rawState[STORE_QUALITIES],
      stores[STORE_CONFIG],
      stores[STORE_AUTH]
    );
    stores[STORE_MIXES] = new MixesStore(
      rawState[STORE_MIXES],
      stores[STORE_CONFIG],
      stores[STORE_AUTH]
    );
    stores[STORE_STAT_ACTIVITY] = new StatActivityStore(
      rawState[STORE_STAT_ACTIVITY],
      stores[STORE_CONFIG],
      stores[STORE_AUTH]
    );
    stores[STORE_PALLET_CHECK] = new PalletCheckStore(
      rawState[STORE_PALLET_CHECK],
      stores[STORE_CONFIG],
      stores[STORE_AUTH]
    );
    stores[STORE_TRANSPORTER_MOVE] = new TransporterMoveStore(
      rawState[STORE_TRANSPORTER_MOVE],
      stores[STORE_CONFIG],
      stores[STORE_AUTH]
    );
    stores[STORE_TRANSPORTER_CHECK] = new TransporterCheckStore(
      rawState[STORE_TRANSPORTER_CHECK],
      stores[STORE_CONFIG],
      stores[STORE_AUTH]
    );

    this.stores = stores;
  }

  get(storeName) {
    return this.stores[storeName];
  }

  toJS() {
    const js = {};
    const entries = Object.entries(this.stores);
    for (let [storeName, store] of entries) {
      if (typeof store.toJS !== "undefined") {
        const childJs = store.toJS();
        if (childJs) {
          js[storeName] = Object.keys(childJs).length ? childJs : undefined;
        }
      }
    }
    return js;
  }
}
export { AppStore };
